import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { User } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${User.Pages.PROFILE}`,
    name: User.Pages.PROFILE,
    component: () => import(/* webpackChunkName: "profile" */ './views/Profile.vue'),
    meta: {
      access_roles: RouteRoles[User.Pages.PROFILE],
    },
  },
  {
    path: `/${User.Pages.PROFILE}/${User.Pages.CHANGE_PASSWORD}`,
    name: User.Pages.CHANGE_PASSWORD,
    component: () => import(/* webpackChunkName: "change-profile-password" */ './views/ChangePasswordView.vue'),
    meta: {
      access_roles: RouteRoles[User.Pages.CHANGE_PASSWORD],
    },
  },
  {
    path: `/${User.Pages.PROFILE}/${User.Pages.CHANGE_EMAIL}`,
    name: User.Pages.CHANGE_EMAIL,
    component: () => import(/* webpackChunkName: "change-profile-email" */ './views/ChangeEmailView.vue'),
    meta: {
      access_roles: RouteRoles[User.Pages.CHANGE_EMAIL],
    },
  },
];

export default routes;
